export default function StatsSection() {
  const stats = [
    { value: '5000万+', label: '注册用户', icon: 'ri-user-line' },
    { value: '2000万+', label: '月活跃用户', icon: 'ri-fire-line' },
    { value: '100万+', label: '每日新视频', icon: 'ri-video-line' },
    { value: '50亿+', label: '累计播放量', icon: 'ri-play-circle-line' },
  ];

  return (
    <section className="py-14 md:py-20 bg-accent-500">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            紅桃視頻的成长数据
          </h2>
          <p className="text-background-50/70 text-sm md:text-base">
            每一组数字背后，都是用户对我们的信任与支持
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-background-50 text-2xl md:text-3xl`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-background-50/70">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}